import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  InputBase,
  Box,
  Tooltip,
} from '@mui/material';
import { Add, Search, Close, ExpandMore, ExpandLess } from '@mui/icons-material';
import MainContentContainer from './../../MainContentContainer/MainContentContainer';
import SessionsTable from './../../SessionsTable/SessionsTable';

const SessionsPage = () => {
  const searchInputRef = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [allExpanded, setAllExpanded] = useState(true);
  const [isGroupedView, setIsGroupedView] = useState(false); // Full list as default

  useEffect(() => {
    const handleKeyDown = (e) => {
      // Check for Cmd+F (Mac) or Ctrl+F (Windows/Linux)
      if ((e.metaKey || e.ctrlKey) && e.key === 'f' && e.shiftKey) {
        e.preventDefault();
        if (!isSearchOpen) {
          handleToggleSearch();
        }
      }
      // Close search with Escape
      if (e.key === 'Escape' && isSearchOpen) {
        e.preventDefault();
        handleToggleSearch();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isSearchOpen]);

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handleToggleSearch = () => {
    setIsSearchOpen((prev) => !prev);
    if (isSearchOpen) {
      setSearchText("");
    } else {
      setTimeout(() => {
        searchInputRef.current?.focus();
      }, 0);
    }
  };

  return (
    <MainContentContainer>
      <AppBar position="sticky">
        <Toolbar>
          {isSearchOpen ? (
            <Box display="flex" alignItems="center" flexGrow={1}>
              <InputBase
                inputRef={searchInputRef}
                value={searchText}
                onChange={handleSearchChange}
                sx={{ flexGrow: 1, px: 1, border: "1px solid #ccc", borderRadius: 1, backgroundColor: "white" }}
                placeholder="Search sessions..."
              />
              <IconButton color="inherit" onClick={handleToggleSearch}>
                <Close />
              </IconButton>
            </Box>
          ) : (
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              Sessions
            </Typography>
          )}
          <Tooltip title="Search (⌘F)">
            <IconButton color="inherit" onClick={handleToggleSearch}>
              <Search />
            </IconButton>
          </Tooltip>

          {isGroupedView && (
            <Tooltip title={allExpanded ? "Collapse All" : "Expand All"}>
              <IconButton color="inherit" onClick={() => setAllExpanded((prev) => !prev)}>
                {allExpanded ? <ExpandLess /> : <ExpandMore />}
              </IconButton>
            </Tooltip>
          )}
          <Button
            color="inherit"
            component={Link}
            to="/sessions/add"
            startIcon={<Add />}
            sx={{
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)'
              }
            }}
          >
            Add Session
          </Button>
        </Toolbar>
      </AppBar>
      <SessionsTable searchText={searchText} allExpanded={allExpanded} isGroupedView={isGroupedView} />
    </MainContentContainer>
  );
};

export default SessionsPage;
